/**
 * The Sentry release comes from the build, never a hard-coded number (FE-13):
 *   ng build --configuration production --define "JFT_RELEASE='jft-frontend@<git sha>'"
 * Without that define the event carries no release (better than a wrong one).
 */
declare const JFT_RELEASE: string | undefined;

export function releaseFrom(value: unknown): string | undefined {
    if (typeof value !== 'string') {
        return undefined;
    }
    const trimmed = value.trim();
    return trimmed || undefined;
}

export const SENTRY_RELEASE: string | undefined =
    releaseFrom(typeof JFT_RELEASE !== 'undefined' ? JFT_RELEASE : undefined);
